<template>
  <div>
    <div data-v-2f725251="">
      <Top></Top>
      <!-- 搜索 -->
      <!-- 第一种样式 -->
      <div v-if="isShowSearch">
        <div class="xmfk_home_topbg">
          <div class="xmfk_home_top_search">
            <div class="xmfk_home_top_search_left">
              <!-- <a class="xmfk_logo_wrap">
                                <img src="/" alt="logo">
                            </a>
                            <div class="xmfk_logo_name">
                                <div class="logo_name">产业B2B交易中心</div>
                                <div class="logo_title">货源稳定 品质恒定的采购平台</div>
                            </div> -->
              <a class="xmfk_logo_wrap" :style="{'max-width':(400-titleWidth-10)+'px'}" @click="openNewWindow(redirectUrl+'/mall', false)">
                <img
                  v-if="b2bWebInfo.logo"
                  :src="commenUrl + b2bWebInfo.logo"
                  alt="logo"
                  class="logo"
                   @load="getImg"
                />
              </a>
              <div class="xmfk_logo_name" :style='{width:titleWidth+"px"}'>
                  <div class="logo_name" :style='{width:titleWidth+"px"}'>{{b2bWebInfo.name}}</div>
                  <div class="logo_title" :style='{width:titleWidth+"px"}'>{{b2bWebInfo.subName}}</div>
              </div>
            </div>
            <div class="xmfk_home_top_search_right">
              <div class="xmfk_seach_wrap">
                <div class="xmfk_seach_form">
                    <input
                      type="text"
                      @keyup.enter="searchFn(searchKeyWord)"
                      v-model="searchKeyWord"
                      class="xmfk_seach_text"
                      autocomplete="off"
                      :placeholder="$t('commonConfiguration.Placeholder.placeholder1')"
                    />
                    <input
                      type="submit"
                      @click="searchFn(searchKeyWord)"
                      class="xmfk_seach_button"
                      :value="$t('commonConfiguration.Button.button1')"
                    />
                  </div>
                <!-- <div class="xmfk_seach_box ld">
                  <div class="form">
                    <input
                      type="text"
                      @keyup.enter="searchFn(searchKeyWord)"
                      v-model="searchKeyWord"
                      class="text"
                      autocomplete="off"
                      :placeholder="$t('commonConfiguration.Placeholder.placeholder1')"
                      style="color: rgb(153, 153, 153)"
                    />
                    <input
                      type="submit"
                      @click="searchFn(searchKeyWord)"
                      class="button"
                      :value="$t('commonConfiguration.Button.button1')"
                    />
                  </div>
                  <div class="hot_search_wrap">
                    <div>
                      <a
                        href="javascript:void(0)"
                        v-for="(searchLi, searchIndex) in searchList"
                        :key="searchIndex"
                        @click="searchFn(searchLi.label)"
                        >{{ searchLi.label }}</a
                      >
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="xmfk_cart_wrap">
                <svg-icon class="icon" iconName="icon-gouwuche"></svg-icon>
                <a href="javascript:void(0)" @click="toHref('/shopCart',true)"
                  >{{$t('commonConfiguration.Button.button10')}}</a
                >
                <div class="cart_goods_num">{{ prodoucCount }}</div>
              </div>
            </div>
          </div>
          <div class="nav_cat" :class="'wui-column-background-'+b2bWebInfo.theme">
            <ul class="header">
              <li
                v-for="(navLi, navIndex) in navList"
                :key="navIndex"
                :class="{ active: navIndex == selectId }"
                @click="toColumn(navLi, navIndex)"
              >
                <img v-if="navLi.columnBanner" :src="commenUrl+navLi.columnBanner" />
                <a>{{ navLi.columnName }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 第二种样式 -->
      <div class="nav_wraptwo" style="display: none">
        <div class="nav_wraptwo_menu">
          <a class="logo_wrap">
            <img src="../../../../assets/images/logo.jpeg" alt="logo" />
          </a>
          <ul class="nav_wraptwo_list">
            <li
              v-for="(navLi, navIndex) in navList"
              :key="navIndex"
              :class="{ active: navIndex == selectId }"
              @click="toColumn(navLi, navIndex)"
            >
              <a>{{ navLi.columnName }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <!-- <iframe src="https://nfstzx.com" style="display:none"></iframe> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import Top from "@/components/dealTop/top.vue";
export default {
  computed: {
    ...mapState({
      userInfoB2B: (state) => state.userInfoB2B,
    }),
  },
  props:{
    isShowSearch:{
      type:Boolean,
      default:true
    }
  },
};
</script>
<script setup>
import "../../css/index.css";
import { ref, computed, getCurrentInstance, onMounted, inject, watch} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'
import operate from "../../js/operate.js";
import { useStore } from "vuex";
import lang from "@/lang";
import SearchDataDict from '@/assets/js/config/search.js'
const { proxy } = getCurrentInstance();
const store = useStore();
const route = useRoute();

const b2bWebInfo = computed(() => store.state.b2bWebInfo);
const dropdown = ref()
const flag = ref(false)
const { locale } = useI18n()
const changeLang = (lang) => {
  if(lang==locale.value){
       return
  }
  proxy.$store.commit("localeB2B", lang);
  // locale.value = lang
  proxy.setCookie("lang", lang);
  // getSearchList()
  // flag.value=true
  // setTimeout(() => {
  //    flag.value=false
  // }, 500);
  location.reload()
}
const langArray = ref(lang.language)
const langArray1 = ref(lang.language1)
const navList = ref([
  {
    columnName: locale.value=='zh'?'首页':'Home',
    columnProperty: "1",
    columnContent: '{"href":"/"}',
    target: "1",
  },
]);
const userInfoB2B = ref(
  proxy.getCookie("userInfoB2B")
    ? JSON.parse(proxy.getCookie("userInfoB2B")).user
    : { loginName: "" }
);
const router = useRouter();
const showEdit = inject("show");
const preview = true;
const prodoucCount = ref(0);
onMounted(() => {
  //   楼层数据处理
  if (userInfoB2B.value.id) {
    getProductCount();
  }
  getWebImageInfo();
  
  window.addEventListener('message', (e) => {
    if (e.data.action === 'logout') {
      localStorage.clear();
      sessionStorage.clear();
    }
  });
});
const titleWidth= ref(0)
if(b2bWebInfo.name){
  let fontLength = b2bWebInfo.name.length>b2bWebInfo.subName.length?b2bWebInfo.name.length:b2bWebInfo.subName.length
  let showLength = module.value == '01'?10:10
  let showWeight = module.value == '01'?200:200
  titleWidth.value =fontLength*showLength>showWeight?showWeight:fontLength*showLength
}
const logoWidth = ref('100%')
const getImg = e=>{
  logoWidth.value = document.getElementsByClassName('logo')[0].width
}
watch(b2bWebInfo,(e)=>{
  let fontLength = e.name.length>e.subName.length?e.name.length:e.subName.length
  let showLength = module.value == '01'?10:10
  let showWeight = module.value == '01'?200:200
  titleWidth.value = fontLength*showLength>showWeight?showWeight:fontLength*showLength
})
watch(logoWidth,(e)=>{
  titleWidth.value = 400-10-e
})
const infoData = ref({ logo: "" });
const getWebImageInfo = () => {
  proxy
    .$request({
      url: "N_SYSTEMCONFIG_GETWEBBASEPICCONFIG",
      method: "post",
    })
    .then((res) => {
      if (res.data.code == "000") {
        infoData.value.logo = res.data.result.mallLogo;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const getProductCount = (e) => {
  proxy
    .$request({
      url: "B2B_FINDPRODUCTCOUNT",
      method: "post", //可以不传method 默认是post请求，
      data: {
        isLoginType: "1",
      },
    })
    .then((res) => {
      if (res.data.code == "000") {
        prodoucCount.value = res.data.result;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
const openNewWindow = (e) => {
  proxy.tool.openWindow(e);
}

const toHref = (e, t, jump) => {
  console.log(e)
  if (!preview) return;
  var localObj = window.location;
  if(jump=='target'){
    
    proxy.tool.openWindow(localObj.protocol + "//" + localObj.host + e);
  }else{
    if (t && !proxy.userInfoB2B?.loginName) {
      // router.push({
      //   path: "/login",
      //   query: {},
      // });
      if(process.env.NODE_ENV=="test"){
        proxy.tool.openWindow(localObj.protocol + "//" + localObj.host + "/nfstzx/login?redirect_url="+localObj.href);
      }else{
        proxy.tool.openWindow(proxy.redirectUrl+"/login?redirect_url="+localObj.href);
      }
      
    } else {
      router.push({
        path: e,
        query: {},
      });
    }
  }
  
};
const selectId = ref(0);
const toColumn = (e, id) => {
  selectId.value = id;
  toPage({
    data: JSON.parse(e.columnContent),
    type: e.columnProperty,
    target: e.target,
  });
};
// 跳转处理
const toPage = (e) => {
  let href = "";
  let str = "";
  if (e.type == "0") {
    // 无操作
  } else if (e.type == "1") {
    //
    href = e.data.href;
  } else {
    let operateLi = operate.find((l) => e.type == l.value);
    href = operateLi.href;
    e.inner = operateLi.inner;
    e.target = "1"
    if(operateLi.parameter&&operateLi.parameter.length>0){
      operateLi.parameter.forEach((element,index) => {
        let arr = element.value.split(',')
        let name =''
        if(arr.length>1){
          arr.forEach(m=>{
            if(!name){
              name = e.data[m]
            }
          })
        }else{
          name = e.data[element.value]
        }
        if(index==0){
          str += "?"+element.name+"=" + name
        }else{
          str += "&"+element.name+"=" + name
        }
      });
    }
  }
  openWindow(href, e.target, e.inner, str);
};
const openWindow = (href, target, inner, str) => {
  if (!href) return;
  if (target == "1") {
    // 当前页签打开
    router.push(href + str);
  } else {
    if (inner) {
      const url = router.resolve({
        path: href,
      });
      proxy.tool.openWindow(url.href + str);
    } else {
      proxy.tool.openWindow(href);
    }
  }
};
// 搜索处理
const searchKeyWord = ref("");
// 搜索历史
const searchList = ref([
]);
const getSearchList = (e) => {
  let projectSearch = SearchDataDict.find(e=>e.project==process.argv.project)
  searchList.value = projectSearch?projectSearch[locale.value]:[]
}
onMounted(() => {
  init();
});
const searchFn = (searchKeyWord) => {
  if (!preview) return;
  
  if (searchKeyWord) {
    router.push({ path: "/goodsList", query: { searchKey: searchKeyWord } });
  } else {
    if(route.path=="/goodsList"){
      router.push({
        path: "/goodsList",
        query: { 
          _refresh: Date.now() 
        }
      });
    }else{
      router.push({ path: "/goodsList" });
    }
  }
};
// 用户登录或者退出操作
const emits = defineEmits(["operate", "save"]);
const jumper = (href) => {
  if (!preview) return;
  toPage({ data: { href: href }, type: "1", inner: true });
};
const init = () => {
  proxy
    .$request({
      url: "B2B_W_INDUSTRYCOLUMNMANAGE_FINDLIST",
      method: "post", //可以不传method 默认是post请求，
      data: {
        isShow: "0",
      },
    })
    .then((res) => {
      if (res.data.code == "000") {
        navList.value = navList.value.concat(res.data.result);
        //查询当前路由是否为配置项 
        navList.value.forEach((navLi,navIndex) => {
          let columnContent = {}
          if(navLi.columnProperty!='1')return
          if(navLi.columnContent)columnContent = JSON.parse(navLi.columnContent)
          console.log(decodeURIComponent(window.location.href),columnContent.href)
          if(decodeURIComponent(window.location.href) == columnContent.href){
            selectId.value = navIndex
          }
        })
        let urlJson = operate.find((e) => e.href == route.path);
        if (urlJson) {
          // 当路由属于配置项时，查询符合条件的菜单
          let id = route.query.id||route.query.categoryId||route.query.pid||route.query.commSaleCatgId
          // let headJson = navList.value.find((e) =>{
          //   if(e.columnProperty != urlJson.value)return
          //   if(id&&id==e.id)return e
          // } )
          if(id){
            let headList = []
            navList.value.forEach((navLi,navIndex) => {
              navLi.index = navIndex
              if (navLi.columnProperty == urlJson.value) {
                headList.push(navLi)
              }
            })
            if(headList.length>0){
              // 符合条件的菜单
              const headJson = headList.find((e,index) => {
                let columnContent = e.columnContent?JSON.parse(e.columnContent):'id'
                let headId = 'id'
                if(urlJson.parameter&&urlJson.parameter.length>0){
                  urlJson.parameter.forEach((element,index) => {
                    let arr = element.value.split(',')
                    let name =''
                    // console.log(arr,element.value,'11111111111111111111111111111111')
                    if(arr.length>1){
                      arr.forEach(m=>{
                        if(!name){
                          // name = e.data[m]
                          if(columnContent[m]){
                            headId = columnContent[m]
                          }
                        }
                      })
                    }else{
                      // console.log( columnContent[element.value])
                          if(element.value=='pid')element.value = id
                          if(columnContent[element.value]){
                            headId = columnContent[element.value]
                          }
                      
                      // name = e.data[element.value]
                    }
                  });
                }
                if(headId&&headId == id){
                  return e
                }
              })
              if(headJson){
                selectId.value = headJson.index
              }
              

            }
          }else{
              // 如果没有配置参数
              if(!urlJson.parameter){
                let navIndex = navList.value.findIndex((navLi) => navLi.columnProperty == urlJson.value)
                selectId.value = navIndex
             }
          } 

          
        }
        
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
function deleteCookie(name, path = '/', domain = "") {
    document.cookie = `${name}=; path=${path}; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
}
const logout = () => {
  //退出
  proxy
    .$request({
      method: "post",
      url: "SECURITY_W_LOGOUT",
      data: {},
    })
    .then((res) => {
      var data = res.data;
      if (data.code == "000") {
        proxy.setCookie("userInfoB2B", "");
        proxy.$store.commit("setUserInfoB2B", "");
        proxy.setCookie("membIdB2B", "");
        userInfoB2B.value = {}
        // const iframe = document.querySelector('iframe');
        // iframe.contentWindow.postMessage({ action:'logout'},'https://nfstzx.com');
        // deleteCookie('wbf_access_token');
        // document.cookie = "wbf_access_token=; domain=nfstzx.com; path=/";
        // document.cookie = "AUTH=; domain=nfstzx.com; path=/";
      } else {
        proxy.$alert(data.msg || "系统错误...", "错误提示", {
          cofirmButtonText: "确定",
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
</script>
<style lang="less" scoped>
.xmfk_logo_wrap {
  // margin-right: 120px;
}
.li_item:focus-visible{
  outline: none;
}
.li_item{
  height: 14px !important;
}
.disflex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>